class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.closeStartDelay = 60;
    this.closeAnimationDuration = 220;
    this.closeStartTimer = null;
    this.closeCompleteTimer = null;
    this.desktopHoverMediaQuery = window.matchMedia('(hover: hover) and (pointer: fine) and (min-width: 990px)');

    this.onMouseEnter = this.onMouseEnter.bind(this);
    this.onMouseLeave = this.onMouseLeave.bind(this);

    this.addEventListener('mouseenter', this.onMouseEnter);
    this.addEventListener('mouseleave', this.onMouseLeave);
  }

  onMouseEnter() {
    if (!this.desktopHoverMediaQuery.matches) return;

    window.clearTimeout(this.closeStartTimer);
    window.clearTimeout(this.closeCompleteTimer);
    this.mainDetailsToggle.classList.remove('is-closing');

    if (!this.mainDetailsToggle.hasAttribute('open')) {
      this.mainDetailsToggle.setAttribute('open', '');
    }

    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', true);
  }

  onMouseLeave() {
    if (!this.desktopHoverMediaQuery.matches) return;

    window.clearTimeout(this.closeStartTimer);
    this.closeStartTimer = window.setTimeout(() => {
      this.close();
    }, this.closeStartDelay);
  }

  close() {
    if (!this.desktopHoverMediaQuery.matches) {
      super.close();
      return;
    }

    window.clearTimeout(this.closeStartTimer);
    window.clearTimeout(this.closeCompleteTimer);

    if (!this.mainDetailsToggle.hasAttribute('open')) return;

    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
    this.mainDetailsToggle.classList.add('is-closing');

    this.closeCompleteTimer = window.setTimeout(() => {
      this.mainDetailsToggle.classList.remove('is-closing');
      this.mainDetailsToggle.removeAttribute('open');
    }, this.closeAnimationDuration);
  }

  onToggle() {
    if (!this.header) return;
    this.mainDetailsToggle.classList.remove('is-closing');
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`,
    );
  }
}

customElements.define('header-menu', HeaderMenu);
